import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MessagesSquare, PictureInPicture2, X } from "lucide-react";
import { useApp } from "../context/AppContext";
import ChatHub from "./ChatHub";
import { popoutBus, popoutPath, savePopRect, sendToMain, POP_NAME } from "../lib/commPopout";

/* 独立聊天窗口（window.open 弹出，可拖到第二块屏幕 · 系统最大化 / 还原 / 最小化）：顶部细条 + 完整 /chat 三栏；
   每 2s 向主页面心跳；关闭 / 收回时通知主页面恢复悬浮窗；窗口位置大小持续记忆 */
export default function ChatPopout() {
  const { lang, user } = useApp();
  const zh = lang !== "en";
  const nav = useNavigate();

  useEffect(() => {
    if (!window.name) window.name = POP_NAME;
    document.title = zh ? "ALIGCUS 沟通 · 聊天" : "ALIGCUS Chat";
    const bus = popoutBus();
    const alive = () => bus?.postMessage({ type: "alive", at: Date.now() });
    const geo = () => savePopRect({ x: window.screenX, y: window.screenY, w: window.outerWidth, h: window.outerHeight });
    alive(); geo();
    const t1 = setInterval(alive, 2000);
    const t2 = setInterval(geo, 3000);
    window.addEventListener("resize", geo);
    if (bus) bus.onmessage = (e) => {
      const m = e.data || {};
      if (m.type === "open") { nav(popoutPath(m)); try { window.focus(); } catch { /* ignore */ } }
      else if (m.type === "focus") { try { window.focus(); } catch { /* ignore */ } }
      else if (m.type === "close") { geo(); window.close(); }
    };
    const bye = () => { geo(); bus?.postMessage({ type: "closed" }); };
    window.addEventListener("pagehide", bye);
    return () => { clearInterval(t1); clearInterval(t2); window.removeEventListener("resize", geo); window.removeEventListener("pagehide", bye); bus?.close(); };
  }, [nav, zh]);

  const back = () => { sendToMain({ type: "return" }); setTimeout(() => window.close(), 80); };

  return (
    <div className="h-[100dvh] flex flex-col bg-[#f8faff] text-slate-900" data-testid="chat-popout" data-user={user?.username || ""}>
      <header className="h-10 shrink-0 flex items-center gap-2 px-3 bg-white border-b border-slate-200" data-testid="chat-popout-bar">
        <span className="h-6 w-6 rounded-lg bg-brand-grad text-white flex items-center justify-center"><MessagesSquare className="h-3.5 w-3.5" /></span>
        <span className="text-xs font-semibold text-slate-700 truncate">{zh ? "ALIGCUS 沟通 · 聊天" : "ALIGCUS Chat"}</span>
        <span className="hidden sm:inline text-[10px] text-slate-400 truncate">{zh ? "独立窗口：可拖到另一块屏幕，用系统按钮最大化 / 还原 / 最小化；位置大小自动记忆" : "Pop-out: drag to another display · use OS buttons to maximize / restore / minimize"}</span>
        <span className="flex-1" />
        <button type="button" data-testid="chat-popout-return" onClick={back} title={zh ? "收回到主页面悬浮窗" : "Return to the main page"}
          className="inline-flex items-center gap-1 h-7 rounded-lg border border-indigo-200 bg-indigo-50 text-[#4F6BFF] text-[11px] font-semibold px-2.5 hover:bg-indigo-100 transition-colors"><PictureInPicture2 className="h-3.5 w-3.5" />{zh ? "收回到主页面" : "Return"}</button>
        <button type="button" data-testid="chat-popout-close" onClick={() => window.close()} title={zh ? "关闭窗口" : "Close"}
          className="h-7 w-7 rounded-lg flex items-center justify-center text-slate-500 hover:bg-red-600 hover:text-white transition-colors"><X className="h-3.5 w-3.5" /></button>
      </header>
      <div className="flex-1 min-h-0 p-2">
        <ChatHub popout />
      </div>
    </div>
  );
}
